import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';
import { NavLink } from 'react-router-dom';
import { MenuContext } from '../../contexts/MenuContext';
import Button from '../../globals/Button';
import { AuthContext } from '../../contexts/AuthContext';
import ENDPOINT from '../../globals/api-endpoint';

const Li = styled.li`
	list-style-type: none;
	text-align: center;
	padding: 12px;
`;

const DrawerStyled = styled.button`
	border-width : 0;
	display: none;
	background: white;
	font-size: 30px;
	text-align : center;
	cursor: pointer;
	width: 100%;
	&:hover {
		color: ${props => props.theme.purple};
	}
	${media.lessThan('medium')`
		display : inline-block;
	`}
	${props => {
		if(props.appear) {
			return `color: ${props.theme.purple};`;
		}
	}}
`;

const Ul = styled.ul`
	position: fixed;
	top : 50px;
	right: 0;
	background: white;
	min-width: 150px;
	-webkit-transform: translate(200px, 0);
  transform: translate(200px, 0);
  transition: transform 0.5s ease;
	${props => {
		if(props.appear) {
			return `
			-webkit-transform: translate(0, 0);
      transform: translate(0, 0);`;
		}
	}}
	${media.greaterThan('medium')`
		display : none;
	`}
`;

const DrawerMenu = styled.div`
	text-align: center;
`;

const Drawer = () => {
	const { menus } = useContext(MenuContext);
	const { auth, dispatch } = useContext(AuthContext);
	const menuList = menus.menuList;

	const [Appear, setAppear] = useState(false);

	const [token, setToken] = useState({
		authToken: localStorage.getItem('authToken')
	});

	const isAuth = auth.isAuth;
	const [isLoading, setIsLoading] = useState(true);

	const localToken = JSON.parse(token.authToken);
	const tokenFromStorage = localToken ? (localToken.token) : (null);

	useEffect(() => {
		setToken({
			authToken: localStorage.getItem('authToken')
		});
	}, [])

	useEffect(() => {
		const fetchData = () => { 
			setIsLoading(true);
			fetch(ENDPOINT.CHECK_AUTH, {
				headers: {
					Authorization: tokenFromStorage
				}
			})
			.then(res => res.json())
			.then(res => {
				if (res.message === 'Auth succesful') {
					dispatch({ type: 'SWITCH_AUTH', auth: true });
				} else {
					dispatch({ type: 'SWITCH_AUTH', auth: false })
				}
			})
			.catch(err => {
				console.log(err);
			})
			.finally(res => {
				setIsLoading(false);
			});
		}
		fetchData();
	}, [dispatch, tokenFromStorage]);

	const handleMenuClick = (e) => {
		e.preventDefault();
		setAppear(false);
	}

	const isAuthMenu = isAuth ? (
		<Li key={auth} onClick={handleMenuClick}><NavLink to={'/me'}>
			Profil
		</NavLink></Li>
	) : (
		<Li key={auth} onClick={handleMenuClick}><NavLink to={'/login'}>
			<Button bg='purple'>
				Memulai
			</Button>
		</NavLink></Li>
	);

	const menu = menuList.map(menu => {
		return <Li key={menu} onClick={handleMenuClick}><NavLink to={'/' + menu.toLowerCase()}>{menu}</NavLink></Li>;
	});

	const handleClick = (e) => {
		e.preventDefault();
		setAppear(!Appear);
	}

	const menuview = (
		<Ul appear={Appear}>
			{ menu }
			{ isLoading ? (null) : (isAuthMenu) }
		</Ul>
	);

	return(
		<DrawerMenu>
			<DrawerStyled onClick={handleClick} appear={Appear}>
				☰
			</DrawerStyled>
			{ menuview }
		</DrawerMenu>
	)
}

export default Drawer;